// extracted by mini-css-extract-plugin
module.exports = {"featuresRow":"Features_featuresRow__13HrQ","item":"Features_item__3tOHa"};